import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class ThemeService {
    documentElement: HTMLElement;

    constructor() {
        this.documentElement = document.documentElement;
    }

    setTheme(theme: 'mv' | 'mv-market-dealers') {
        if (this.documentElement.getAttribute('theme') == theme) {
            return;
        }

        this.documentElement.setAttribute('theme', theme);
    }

    setPriceBlur(blurPrices: boolean = false) {
         if (this.documentElement.getAttribute('blur') == 'prices') {
            return;
        }

        this.documentElement.setAttribute('blur', 'prices');
    }
}